module.exports = __webpack_public_path__ + "img/Picture13.b71c2ea8.png";